// =====================================================================
// perfisMarketing.js — QUEM ALCANÇA o módulo Marketing (lado da tela)
// =====================================================================
// O módulo nasceu em 16/09/2026 para três perfis (`Marketing`, `Diretoria` e
// `Admin`) e foi ABERTO em 18/09/2026, a pedido da Julia, para quem anuncia vaga
// e comemora aniversário na ponta: a loja (`Gerente`, `Gerente Plantao`,
// `Coordenador de Qualidade`) e as áreas de gente e de operação.
//
// ⚠️ ESTA LISTA EXISTE PARA SER UMA SÓ NO FRONT: o `allowedRoles` da rota
//    `/marketing` (App.js) e o `canSeeMarketing` (menu-itens.js) consomem daqui.
//    Eram duas listas escritas à mão que precisavam ser iguais — e a que
//    envelhece sozinha é sempre a que ninguém lembra que existe. O espelho do
//    BACKEND é o `PERFIS` de `server/marketing/server-marketing.js`, que é a
//    trava de verdade; este arquivo só decide o que aparece.
//
// ⚠️ NÃO entram aqui: `Admin` (bypass), `Diretoria` (escrita na rota) e os
//    perfis DERIVADOS — `Marketing` e `Diretoria Op` chegam pelo
//    `perfisDoModulo('marketing')`, que lê o `perfisDerivados.js`. Escrever o
//    nome de um derivado aqui criaria uma segunda verdade sobre o recorte dele.
//    ⚠️ `Diretoria RH` segue FORA: não foi pedida.
export const PERFIS_MARKETING = [
    // A loja: é ela que anuncia a própria vaga e imprime a arte do mês.
    'Gerente', 'Gerente Plantao', 'Coordenador de Qualidade',
    // As áreas centrais que usam as duas artes no dia a dia.
    'RH', 'Auditoria', 'Operacional', 'Treinamento',
];
